import React from "react";

import { withStyles } from "@material-ui/styles";
import useStyles from './styles';
import { pathOr } from "ramda";

import { lighten, Box, LinearProgress, Typography,Grid,Tooltip,Button,TextField,Dialog,DialogActions,DialogContent,DialogContentText,DialogTitle } from "@material-ui/core";

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const ProgressBar = ({ color="primary", hex,data,percent=0 ,allTabFilter}) => {
  const classes = useStyles();
  let internalColor: string;
  const [open, setOpen] = React.useState(false);
  const [value,setValue] = React.useState(pathOr( percent, ['0','riskAppetite'], allTabFilter));
  const [dataLength,setDataLength] = React.useState(pathOr(9, ['dataLength'], data));
  const [isProgressText,setIsProgressText] = React.useState(pathOr(true, ['isProgressText'], data));
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const BorderLinearProgress = withStyles({
    root: {
      height: pathOr(30, ['height'], data),
      width: "100%",
      backgroundColor: hex ? lighten(internalColor, 0.5) : undefined,
      borderRadius: "8px"
    },
    bar: {
      borderRadius: 8,
      backgroundColor: hex ? internalColor : undefined
    }
  })(LinearProgress);

  const WhiteTextTypography = withStyles({
    root: {
      color: "#FFFFFF"
    }
  })(Typography);

  return (
    <>
    <Grid
  container
  direction="row"
  // justifyContent="flex-start"
  alignItems="center"
>
   {pathOr(true, ['isFieldLabel'], data)?<Grid item >
         <Typography className={classes.axaLabel} >
        {data.label}
      </Typography>
  </Grid>:null}
  <Grid item >
  {data.isHelpText? <>&nbsp;&nbsp;&nbsp;&nbsp;<Tooltip
      title={data.HelpDescription}
      placement="top-start"
    ><ErrorOutlineIcon color="primary" onClick={handleClickOpen} /></Tooltip></>:null}
  </Grid></Grid>

     
    <Box position="relative" display="inline-flex" style={{ width: "100%" }}>
      <BorderLinearProgress
        color={hex ? undefined : color}
        variant="determinate"
        value={percent?percent:value*(100/dataLength)}
      />
      <Box
        top={3}
        left={10}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="left"
      >
       {isProgressText?<WhiteTextTypography variant="body2">{`${percent?percent:value}`}</WhiteTextTypography>:null}
      </Box>
    </Box>

    {data.isPopupActive ? <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Risk Profile</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Risk Profile Question List
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Risk Answer"
            type="email"
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleClose}>Select</Button>
        </DialogActions>
      </Dialog> : null}
    
 
    </>
  );
};

export default ProgressBar;
